import {Model, ModelMixin} from '../../common/model.class';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class WorkObservations extends ModelMixin() implements Model<WorkObservations> {

    TYPE = WorkObservations;

    public workHistoryGapExplanation: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/observations/work-observations.model.ts